var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHubspotExport = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-hubspot",
    transform: "translate(-983 -490)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 18,
    height: 18,
    transform: "translate(983 490)",
    fill: "#3b3b3b",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "hubspot",
    d: "M20.411,8.935V7.19a1.344,1.344,0,0,0,.775-1.211v-.04a1.344,1.344,0,0,0-1.344-1.344H19.8a1.344,1.344,0,0,0-1.344,1.344v.04a1.344,1.344,0,0,0,.775,1.211V8.935a3.806,3.806,0,0,0-1.81.8L12.637,6a1.53,1.53,0,1,0-.717.931L16.634,10.6a3.818,3.818,0,0,0,.058,4.3l-1.434,1.434a1.268,1.268,0,1,0,.828.828L17.5,15.746a3.824,3.824,0,1,0,2.907-6.811m-.588,5.74a1.963,1.963,0,1,1,1.893-1.963,1.962,1.962,0,0,1-1.893,1.963",
    transform: "translate(975.338 487.563)",
    fill: "#ff7a59"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHubspotExport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hubspotExport.65a8b521.svg";
export { ForwardRef as ReactComponent };